import { Skeleton } from "antd";
import { useState } from "react";
import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import ProductCard from "../../ProductCard/ProductCard";
import styles from "./ProductSlider.module.scss";

// Placeholder cards laid out like the slider (same columns per breakpoint and
// the same image height as ProductCard), so the products drop in without
// pushing the page around.
const ProductSliderSkeleton = () => (
  <div className={styles.skeleton_row} aria-busy="true" aria-label="Loading products">
    {Array.from({ length: 6 }, (_, index) => (
      <div key={index} className={styles.skeleton_card}>
        <Skeleton.Image active className={styles.skeleton_image} />
        <Skeleton active title={{ width: "80%" }} paragraph={{ rows: 2, width: ["50%", "35%"] }} />
        <Skeleton.Button active block />
      </div>
    ))}
  </div>
);

const ProductSlider = ({ title, link, products, showDiscountVariants, loading = false }) => {
  const [, setSlider] = useState({});

  const sliderProps = {
    onInit: (ev) => {
      setSlider(ev);
    },
    modules: [Autoplay],
    loop: false,
    breakpoints: {
      310: {
        slidesPerView: 2,
        spaceBetween: 5,
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 5,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 5,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 15,
      },
      1200: {
        slidesPerView: 6,
        spaceBetween: 15,
      },
    },
  };

  const isDesktopView = window.innerWidth > 575;

  return (
    <div className={isDesktopView ? `container px-0` : ""}>
      <div className={"see_more_title"}>
        <h2>{title}</h2>
      </div>

      {loading && !products.length ? (
        <ProductSliderSkeleton />
      ) : !products.length ? (
        <div>
          <span>No products available for {title}</span>
        </div>
      ) : (
        <div className={styles.product_slider_item}>
          <div className={styles.product_main_slider}>
            <Swiper {...sliderProps} style={{ overflow: "unset" }}>
              {products?.map((product, index) => {
                return (
                  <SwiperSlide key={index}>
                    <ProductCard
                      product={product}
                      discountOnly={showDiscountVariants}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductSlider;
